import { firstValueFrom } from 'rxjs';
import { ConfigurationService } from '../config/configuration.service';
import { MeasureConfig } from '@algomusinc/domain';
import { TreeNode } from 'primeng/api';

/** Fetch and format master measures */
export const fetchAndFormatMasterMeasures = async (
  fbTemplateId: number,
  plannerservice: ConfigurationService
) => {
  let masterMeasures = await firstValueFrom(
    plannerservice.measuresGetList({ FBTemplateId: fbTemplateId })
  );

  return masterMeasures.map((measure: any) => {
    let parentMeasure: any = masterMeasures.find(
      (row) => row.measureId === measure.parentId
    );

    // Configure Measure Colors
    let formattedMeasure = {
      ...measure,
      gridColor: parentMeasure?.background || '',
      graphColor: measure.background || parentMeasure?.background || '',
    };

    // Parse Measure Config
    let measureConfig = new MeasureConfig();
    try {
      const parsedConfig = measure.measureConfig
        ? JSON.parse(measure.measureConfig)
        : '';
      measureConfig = { ...measureConfig, ...parsedConfig };
      delete formattedMeasure.measureConfig;
      formattedMeasure.measureConfigData = measureConfig;
    } catch (e) {
      console.error('Error parsing measure config', e);
    }

    return formattedMeasure;
  });
};
export const processTree = ( treeNodes: Array<TreeNode> | undefined, result: Array<TreeNode> | undefined = []) => {
  if (treeNodes) {
    for (let treeNode of treeNodes) {
      // TODO: process stuff here
      result.push(treeNode);
      if (!treeNode.leaf) processTree(treeNode.children, result);
    }
    return result;
  }
  return result;
};
